import { SSO, USER_MANAGER } from "resources";

export async function getUserData() {
    const response = await fetch(USER_MANAGER.getUserTokenData, {
        method: "GET",
        credentials: "include", // Necessary to ensure cookies are sent and received
    });
    try {
        const data = await response.json();
        return data;
    } catch {
        return { error: true, data: null, message: '' };
    }
};

export async function clearToken() {
    const response = await fetch(SSO.clearToken, {
        method: "GET",
        credentials: "include", // Necessary to ensure cookies are sent and received
    });
    try {
        const data = await response.json();
        return data;
    } catch {
        return { error: true, data: null, message: '' };
    }
};